var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notifications", attrs: { id: "notifications" } },
    [
      _vm.is_need_render_notifications
        ? _c(
            "v-btn",
            {
              staticClass: "notification-btn",
              attrs: {
                color: _vm.only_information ? "white" : "error",
                fab: "",
                "x-small": ""
              },
              on: {
                click: function($event) {
                  return _vm.control_notification_dialog(true)
                }
              }
            },
            [
              _c(
                "v-icon",
                { attrs: { color: _vm.only_information ? "error" : "white" } },
                [_vm._v("\n            icon-notifications\n        ")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "notification-btn__text" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t("__notification.notification_btn_tooltip_text")
                    ) +
                    "\n        "
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.is_need_render_notifications
        ? _c(
            "v-dialog",
            {
              attrs: {
                "content-class": "notifications-dialog",
                "max-width": "684px",
                "min-height": "328px"
              },
              model: {
                value: _vm.notification_dialog,
                callback: function($$v) {
                  _vm.notification_dialog = $$v
                },
                expression: "notification_dialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "notifications-card" },
                [
                  _c(
                    "v-tabs",
                    {
                      staticClass: "notifications-tabs",
                      attrs: {
                        "background-color": "dark-blue",
                        color: "white",
                        centered: "",
                        dark: ""
                      },
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c("v-tabs-slider", { attrs: { color: "red" } }),
                      _vm._v(" "),
                      _vm._l(_vm.tab_options, function(tab_option) {
                        return _c("v-tab", { key: tab_option }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(tab_option) +
                              "\n                "
                          )
                        ])
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "notifications-tabs__close-btn",
                      attrs: { color: "white" },
                      on: {
                        click: function($event) {
                          return _vm.control_notification_dialog(false)
                        }
                      }
                    },
                    [_vm._v("\n                icon-close\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notifications-tabs__items" },
                    [
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        _vm._l(_vm.tab_options, function(tab_option) {
                          return _c(
                            "v-tab-item",
                            { key: tab_option },
                            [
                              tab_option ==
                              _vm.$t("__notification.severe_weather_advisories")
                                ? _c("AlertMessage", {
                                    attrs: {
                                      alert_messages: _vm.alert_messages
                                    }
                                  })
                                : _c("Information", {
                                    attrs: {
                                      props_information: _vm.information
                                    }
                                  })
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }